// project import
import Navigation from './Navigation';
import SimpleBar from '../../../../components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBar
    sx={{
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column',
        height:"100%"
      },
      height: 'calc(100vh - 68px)',
    }}
  >
    <Navigation />
    
  </SimpleBar>
);

export default DrawerContent;
